
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class DescriptionOffers extends Vue {
  @Prop(Object) offer!: any;
  @Prop(Boolean) withInfo!: boolean;
  @Prop(Boolean) small!: boolean;
  @Prop(Boolean) withDate!: boolean;
  @Prop(Boolean) fromjoin!: boolean;
  @Prop(String) offerType!: string;
  @Prop(Function) show_detail!: any;
  innerSmall = false;

  mounted() {
    this.innerSmall = this.small;
    this.$nextTick(() => {
      this.innerSmall = this.small;
    });
  }

  show_detail_inner() {
    const offer: any = (this as any).offer;
    if (!this.fromjoin) {
      this.$store.commit("setOffer", offer);
      this.$router.push("ofertas/" + offer.id);
    }
  }
}
